<template>
  <div>
    <div
        :style="`border-radius: 4px;background-color: ${accentColor};color:white;font-size:12px;display:inline;`"
        class="ma-0 mx-2 px-2 py-1"
    >
      {{ text }}
    </div>
    <div class="bottom_triangle">
      <svg
          height="7px"
          id="svg10"
          viewBox="0 0 6.93 6"
          width="6px"
          xmlns="http://www.w3.org/2000/svg"
      >
        <g
            data-name="レイヤー 2"
            id="レイヤー_2"
        >
          <g id="text">
            <polygon
                :style="`fill:${accentColor};`"
                id="polygon6"
                points="6.93 0 0 0 3.47 6 6.93 0"
            />
          </g>
        </g>
      </svg>
    </div>
  </div>
</template>

<script>
export default {
  name: "Bubble",
  props: ["text"],
  data() {
    return {
      accentColor: null,
    }
  },
  mounted() {
    this.accentColor = this.$vuetify.theme.themes.light.secondary
  },
}
</script>

<style>
.bottom_triangle {
  margin-top: -11px;
  margin-left: 30px;
}
</style>
